import "../assets/styles/components/message.scss";

export default function Message({ type, message }) {
  return (
    <div
      className={`position-fixed p-3 w-100 text-center message message--${type}`}
    >
      <strong>{message}</strong>
    </div>
  );
}
